// Basic
import PropTypes from 'prop-types';
// Libs
import { useNavigate } from 'react-router-dom';
// Components
import ChartCard from '@/common-utils/components/renders/chartsCards/ChartCard';
import CardRedirection from '../../common/CardRedirection';
import PieChartCustom from '@/common-utils/components/renders/charts/PieChartCustom';
// Common
import POSTERMINAL_STATS_FIELDS from '../../../fields/PosterminalStatsFields';
import PieChartSkeleton from '../../common/PieChartSkeleton';
import RouteUrls from '@/app/root/enums/RouteUrls';
// Lang
import { nsDashboard } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.dashboardData
 * @returns {JSX} NetworksChart
 */
function NetworksChart({ dashboardData }) {
    // Hooks
    const navigate = useNavigate();

    return (
        <>
            {dashboardData.posTerminalAndSubscriptions?.isFetching &&
                <PieChartSkeleton />
            }
            {!dashboardData.posTerminalAndSubscriptions?.isFetching && (
                <ChartCard
                    title='charts.terminals.networks.title'
                    tooltipEntity='charts.terminals.networks.tooltip'
                    namespace={nsDashboard}
                >
                    {dashboardData.posTerminalAndSubscriptions?.data && !dashboardData.posTerminalAndSubscriptions?.error && (
                        <PieChartCustom
                            data={dashboardData.posTerminalAndSubscriptions?.data}
                            dataKey={POSTERMINAL_STATS_FIELDS.COMMUNICATION_MODE_BREAKDOWN.key}
                            chartKey='communicationMode'
                            valueKey='count'
                            namespace={nsDashboard}
                        />
                    )}
                    {dashboardData.posTerminalAndSubscriptions?.error && (
                        <CardRedirection
                            buttonEntity='redirection.pos_terminals'
                            namespace={nsDashboard}
                            onClick={() => { navigate(RouteUrls.SUBSCRIPTIONS.url); }}
                        />
                    )}
                </ChartCard>
            )}
        </>
    );
}

NetworksChart.propTypes = {
    dashboardData: PropTypes.object.isRequired
};

export default NetworksChart;